import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createListActions } from './actions';
import { ListActions, ListState } from './types';

export const useListStore = create<ListState & ListActions>()(
    immer((set, get, store) => ({
        lists: [],
        loading: false,
        selectedList: null,
        loadingList: false,
        error: undefined,
        ...createListActions(set, get, store),
    })),
);
